import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuFilterLocation } from './SbSharedRefineMenuFilterLocation';
import { SbSharedRefineMenuShippingFiltersWrapperLazy } from '../SbSharedRefineMenuShippingFilters/SbSharedRefineMenuShippingFiltersWrapperLazy';

export const SbSharedRefineMenuFilterDeliveryOptionsComponent = props => {
    const { isClient, currency, viewer, submitOnBlur } = props;
    const { isDeliveryOptionsDisabled } = viewer;
    return (
        <React.Fragment>
            {/* Shipping filters */}
            {!isDeliveryOptionsDisabled && isClient && (
                <React.Suspense fallback="">
                    <SbSharedRefineMenuShippingFiltersWrapperLazy
                        currency={currency}
                        submitOnBlur={submitOnBlur}
                    />
                </React.Suspense>
            )}
            {/* Item Ships From */}
            <SbSharedRefineMenuFilterLocation {...props} />
        </React.Fragment>
    );
};

SbSharedRefineMenuFilterDeliveryOptionsComponent.propTypes = {
    isClient: PropTypes.bool,
    currency: PropTypes.string.isRequired,
    viewer: PropTypes.object.isRequired,
    submitOnBlur: PropTypes.bool,
};

export const SbSharedRefineMenuFilterDeliveryOptions = createFragmentContainer(
    SbSharedRefineMenuFilterDeliveryOptionsComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterDeliveryOptions_viewer on Viewer {
                isDeliveryOptionsDisabled: isEnabledByLocale(
                    featureName: "DISABLE_SB_DELIVERY_OPTION_FILTERS"
                )
                ...SbSharedRefineMenuFilterLocation_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbSharedRefineMenuFilterDeliveryOptions_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuFilterLocation_itemSearch
            }
        `,
    }
);
